export type TeamLabelBreakpoint = "desktop" | "tablet" | "mobile";

export type ResponsiveTeamLabelTeam = {
  name?: string | null;
  shortName?: string | null;
  tla?: string | null;
};

const mobileFallbackMaxLength = 14;

function cleanLabel(value: string | null | undefined) {
  const label = value?.trim();
  return label ? label : null;
}

function truncateLabel(label: string, maxLength = mobileFallbackMaxLength) {
  if (label.length <= maxLength) return label;
  return `${label.slice(0, Math.max(1, maxLength - 3)).trimEnd()}...`;
}

export function getResponsiveTeamLabel(
  team: ResponsiveTeamLabelTeam | null | undefined,
  breakpoint: TeamLabelBreakpoint,
) {
  const name = cleanLabel(team?.name) ?? "TBA";
  const shortName = cleanLabel(team?.shortName);
  const tla = cleanLabel(team?.tla)?.toUpperCase();

  if (breakpoint === "desktop") return name;
  if (breakpoint === "tablet") return shortName ?? name;

  return tla ?? shortName ?? truncateLabel(name);
}
